import { AxiosResponse } from 'axios';

import { apiVersion } from '@/config';
import { EntityResponse, NerisCheckEnrollmentResponse } from '@/models/neris';

import { http } from './http';

export const NerisApi = {
  checkEnrollment: async (
    entityId: string,
  ): Promise<AxiosResponse<NerisCheckEnrollmentResponse>> => {
    return await http.get(
      `/api/${apiVersion}/neris/check-enrollment/${entityId}`,
    );
  },
  getEntity: async (
    entityId: string,
  ): Promise<AxiosResponse<EntityResponse>> => {
    return await http.get(`/api/${apiVersion}/neris/entity/${entityId}`);
  },
};
